import { Injectable } from '@angular/core';
import { commercialConstants } from 'app/common/commercial-constants';

@Injectable()
export class FormatPolicyNumberService {
    prefixAList: string[] = ['FPKN', 'FPK', 'ACP'];
    // eslint-disable-next-line no-magic-numbers
    prefixPadding = 4;

    constructor() { }

    // Parses the full policy number
    buildPolicyNumber(policy: any, pak: any): string {
        const pakAccountData = pak.policyAccount;
        const policyNumber = `${pakAccountData.prefixA} ${policy.prefixB} ${pakAccountData.branchNumber} ${pakAccountData.decNumber}${pakAccountData.policyNumber}`;

        return policyNumber;
    }

    buildPolicyNumberBasedSearchCriteria(policyNumber): object {
        let numericSection: string;
        let prefixA: string;
        let prefixB: string;
        let policyPrefix: string;
        if (policyNumber.includes('.')) {
            const policyArray = policyNumber.split('.');
            prefixA = policyArray[0];
            prefixB = policyArray[1];
            numericSection = policyArray[2];
        } else {
            policyNumber = policyNumber.replace(' ', '');
            for (const arrayPrefix of this.prefixAList) {
                if (policyNumber.startsWith(arrayPrefix)) {
                    prefixA = arrayPrefix;
                    numericSection = policyNumber.replace(prefixA, '');
                    policyPrefix = numericSection.slice(numericSection.length - 10);
                    prefixB = numericSection.replace(policyPrefix, '');
                    break;
                }
            }
        }
        prefixA = this.padEnd(prefixA, this.prefixPadding);
        prefixB = this.padEnd(prefixB, this.prefixPadding);
        const policyNumberLength = 8;
        const decLength = 3;
        const compressedPolicyNumber = policyNumber.slice(policyNumber.length - policyNumberLength, policyNumber.length);
        const decNumber = compressedPolicyNumber.slice(0, 1);
        const extractedPolicyNumber = compressedPolicyNumber.slice(1, compressedPolicyNumber.length);
        const branchDec = policyPrefix.slice(0, decLength);
        return {
            searchField: {
                name: 'POLICYNO',
                operation: 'EQ',
                value: extractedPolicyNumber + decNumber + prefixA + prefixB + branchDec
            }
        };
    }

    fixDecNumber(policyNumber: string): string {
        const lastIndex = 8;
        if (policyNumber.match(commercialConstants.regexValidators.startsWithAlpha)) {
            const decIndex = policyNumber.length - lastIndex;
            return `${policyNumber.slice(0, Math.max(0, decIndex))}0${policyNumber.slice(Math.max(0, decIndex + 1))}`;
        }
        return policyNumber;
    }

    getFormattedPrefix(prefix: string): string {
        const maxLength = 4;
        return prefix.padEnd(maxLength);
    }

    getPolicyNumberObject(policyNumber: string): any {
        try {
            const policyObject: any = {};
            const trimmedPolicyNumber = policyNumber
                .toUpperCase()
                .replace(/ /g, '');
            for (const arrayPrefix of this.prefixAList) {
                if (trimmedPolicyNumber.startsWith(arrayPrefix)) {
                    const policyNumberLength = 8;
                    policyObject.prefixA = arrayPrefix;
                    let numericSection = trimmedPolicyNumber.replace(
                        policyObject.prefixA,
                        ''
                    );
                    policyObject.prefixB = numericSection.match(/[a-zA-Z]+/)[0];
                    numericSection = numericSection.replace(
                        policyObject.prefixB,
                        ''
                    );
                    const numericLength = 3;
                    const numericSectionPolicyNumber = numericSection.length - policyNumberLength;
                    policyObject.branch = numericSection.slice(0, 2);
                    policyObject.dec = numericSection.slice(2, numericLength);
                    policyObject.policyNum = numericSection.slice(numericLength);
                    policyObject.fullNumber = numericSection;
                    policyObject.fullPolicyNumber = `${numericSection.slice(0, numericSectionPolicyNumber)}0${numericSection.slice(numericSectionPolicyNumber + 1)}`;
                    break;
                }
            }
            return policyObject;
        } catch {
            return undefined;
        }
    }

    padEnd(input: string, length: number): string {
        return input.padEnd(length);
    }

    policyNumbersMatch(policyNumberA: string, policyNumberB: string): boolean {
        const objectA = this.getPolicyNumberObject(policyNumberA);
        const objectB = this.getPolicyNumberObject(policyNumberB);
        return this.prefixAMatches(objectA, objectB) &&
            this.prefixBMatches(objectA, objectB) &&
            this.fullNumberMatches(objectA, objectB);
    }

    private fullNumberMatches(objectA: any, objectB: any): boolean {
        const policyNumberLength = 7;
        return objectA?.fullNumber?.slice(-policyNumberLength) === objectB?.fullNumber?.slice(-policyNumberLength);
    }

    private prefixAMatches(objectA: any, objectB: any): boolean {
        return objectA?.prefixA === objectB?.prefixA;
    }

    private prefixBMatches(objectA: any, objectB: any): boolean {
        return objectA?.prefixB?.slice(0, 2) === objectB?.prefixB?.slice(0, 2);
    }
}
